import { StrictMode } from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import { RouterProvider } from "react-router-dom";
import { DndProvider } from "react-dnd";
import { HTML5Backend } from "react-dnd-html5-backend";

import { NGRouter } from "./NGRouter.tsx";
import "./library/native";
import tracing from "./library/tracing.ts";
import { OidcProvider } from "./library/auth.ts";
import { fixNodeRemoveBug } from "./library/utils.ts";
import {  SnackbarProvider } from "notistack";
import {  StyledEngineProvider } from "@mui/material";
import { getLocalSetting } from "./library/settingsManager.ts";
import { StyledMaterialDesignContent } from "./theme.ts";

import { handleOidcCallback } from "oidc-spa/oidc/handleOidcCallback";
handleOidcCallback();

tracing.createAnnonymousId();

// trigger

fixNodeRemoveBug();

function applyThemeMode() {
  const currentTheme = getLocalSetting("theme", "mode");
  // If theme mode is null or undefined, default to "light" to ensure styles are applied
  const themeMode = currentTheme || "light";
  if (!document.body.classList.contains(`${themeMode}-theme`)) {
    document.body.classList.add(`${themeMode}-theme`);
  }
}

applyThemeMode();

ReactDOM.createRoot(document.getElementById("root") as HTMLElement).render(
  <StrictMode>
    <OidcProvider>
      <DndProvider backend={HTML5Backend}>
        <StyledEngineProvider injectFirst>
          {/* <ThemeProvider theme={currentTheme}> */}
          <SnackbarProvider maxSnack={10} Components={{default: StyledMaterialDesignContent}}>
            {/* <CssBaseline enableColorScheme /> */}
            <RouterProvider router={NGRouter} />
          </SnackbarProvider>
          {/* </ThemeProvider> */}
        </StyledEngineProvider>
      </DndProvider>
    </OidcProvider>
  </StrictMode>
);
